import { useRef, useEffect } from "react";
import * as Yup from "yup";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from 'react-redux';
import { yupResolver } from "@hookform/resolvers/yup";
import PATHS from "../../../routes/paths";
import { useForm, Controller } from "react-hook-form";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from "react-router-dom";
import { useStudentSignUpMutation, useGetCourseListQuery } from "../../../Services/api";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { getData as getCountryData } from 'country-list';

const countries = getCountryData().sort((firstCountry, secondCountry) =>
  firstCountry.name.localeCompare(secondCountry.name)
);

export default function SuginUp() {
  const { id: courseId, countryId } = useParams();
  const validationSchema = Yup.object().shape({
    first_name: Yup.string().required("first name is required"),
    last_name: Yup.string().required("last name is required"),
    nationality: Yup.string().required("country is required"),
    gender: Yup.string().required("gender is required"),
    course_id: Yup.string().required("course name is required"),
    dob: Yup.string().required("date of birth is required"),
    address: Yup.string().required("address is required"),
    company: Yup.string().required("company is required"),
    job_position: Yup.string().required("job title is required"),
    source: Yup.string().required("source is required"),
    phoneNumber: Yup.string().required("mobile number is required"),
    term: Yup.boolean().oneOf([true], "term and condition is required"),
    email: Yup.string().required("Email is required").email("Email is invalid"),
  });
  const navigator = useNavigate();
  const { userDetail } = useSelector((state) => state.auth)
  useEffect(() => {
    if (userDetail) {
      navigator(PATHS.studentDashboard);
    } ///
  }, [userDetail, navigator])
  let defaultValues = {
    first_name: "",
    last_name: "",
    course_id: courseId || "",
    country_id: countryId || "",
  };
  const notify = () => '';
  const methods = useForm({
    mode: "onTouched",
    resolver: yupResolver(validationSchema),
    defaultValues,
  });
  //////////////////////////
  const {
    data: getCourseList
  } = useGetCourseListQuery({ params: '' });
  const courseOptions = courseId
    ? getCourseList?.data?.filter((course) => String(course.course_id) === String(courseId)) || []
    : getCourseList?.data || [];
  //////////////////////////
  const hasShownToast = useRef(false);
  useEffect(() => {
    if (hasShownToast.current) return;
    hasShownToast.current = true;

    const params = new URLSearchParams(window.location.search);
    const payment = params.get('payment');


    if (payment === 'success') {
      toast.success('Payment successful');
    } else if (payment === 'cancelled') {
      toast.error('Payment cancelled');
    }
  }, []);
  const [StudentSignUp, isLoading] = useStudentSignUpMutation();
  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = methods;

  const onSubmit = (values, e) => {
    values['country_id'] = countryId || '';
    StudentSignUp({ data: values })
      .unwrap()
      .then((payload) => {

        if (payload.status) {
          if (payload.data === 0) {
            toast.error(payload.message)
          }
          else {
            // e.target.reset()
            // const response = {
            //   token: payload.token,
            //   user: payload.data,
            // };
            // localStorage.setItem('authType',2);
            // dispatch(loggedIn(response));
            // if(values.course_id !==100 && values.paymentamount > 0){
            //     const { first_name,last_name,course,email,phoneNumber,amount} = values;
            //     window.location.href = "https://qhseinternational.com/payment?first-name="+first_name+"&last-name="+last_name+"&amount="+values.paymentamount+"&your-email="+email+"&phone="+phoneNumber+"&merchant_param1="+course;
            // }

            if (String(values.course_id) !== '100') {

              const { first_name, last_name, course, email, phoneNumber, paymentamount } = values;
              if (countryId !== '2') {
                const selectedCourse = courseOptions[0];

                if (!selectedCourse) {
                  toast.error("Course not found");
                  return;
                }

                // Convert amount JSON string into array
                let amounts = [];

                try {
                  amounts = Array.isArray(selectedCourse.amount)
                    ? selectedCourse.amount
                    : JSON.parse(selectedCourse.amount || "[]");
                } catch (error) {
                  console.error("Invalid course amount:", selectedCourse.amount);
                  toast.error("Invalid course amount");
                  return;
                }

                // Country ID starts from 1, array starts from 0
                const countryIndex = Number(countryId) - 1;

                const paymentAmount = Number(
                  amounts[countryIndex] || 0
                );

                if (paymentAmount <= 0) {
                  toast.error("Amount not found for this country");
                  return;
                }
                
                window.location.href = "https://qhseinternational.com/payment?first-name=" + first_name + "&last-name=" + last_name + "&amount=" + paymentAmount + "&currency=" + "USD" +"&currency_symbol=" + "$" +"&your-email=" + email + "&phone=" + phoneNumber + "&merchant_param1=" + course + "amount=" + paymentAmount;

              } else {
                if (payload.checkoutUrl) {
                  window.location.href = payload.checkoutUrl;
                } else {
                  toast.error('Unable to start Stripe payment');
                }
                return;
              }

            }
            else {
              toast.success('Your are successfully registered please check your email')
              navigator('/login');
            }

          }

        } else {
          toast.error(payload.message)
        }
      })
      .catch((error) => {
        toast.error(error.data.message)
      });
    notify();
  };

  return (
    <main>
      <div className="container">
        <section className="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-12 col-md-12 d-flex flex-column align-items-center justify-content-center">
                <div className="d-flex justify-content-center py-4">
                  <img src="assets/img/logo.png" alt="" />
                </div>
                <div className="card mb-3">
                  <div className="card-body">
                    <div className="pt-4 pb-2">
                      <h5 className="card-title text-center pb-0 fs-4">ELEARNING </h5>

                    </div>
                    <form className="row g-3 needs-validation" >
                      <input type="hidden" {...register("country_id")} />
                      <div className="col-6">
                        <label htmlFor="yourUsername" className="form-label">First Name</label>
                        <div className="input-group has-validation">
                          <input type="name"  {...register("first_name")} className="form-control" id="yourUsername" />
                        </div>
                        <span className="text-danger">{errors.first_name?.message}</span>
                      </div>
                      <div className="col-6">
                        <label htmlFor="yourUsername" className="form-label">Last Name</label>
                        <div className="input-group has-validation">
                          <input type="name"  {...register("last_name")} className="form-control" id="yourUsername" />
                        </div>
                        <span className="text-danger">{errors.last_name?.message}</span>
                      </div>
                      <div className="col-6">
                        <label htmlFor="mobile_number" className="form-label">Mobile Number</label>
                        <div className="input-group has-validation">
                          <Controller
                            name="phoneNumber"
                            className="form-control"
                            control={control}
                            rules={{ required: 'Phone number is required' }}
                            render={({ field }) => (
                              <PhoneInput
                                {...field}
                                country={'pk'} // Replace with the desired default country
                                placeholder="Enter phone number"
                              />
                            )}
                          />
                        </div>
                        <span className="text-danger">{errors.phoneNumber?.message}</span>
                      </div>
                      <div className="col-6">
                        <label htmlFor="yourUsername" className="form-label">Nationality</label>
                        <div className="input-group has-validation">
                          <select id="nationality" {...register("nationality")} className="form-control">
                            <option value="">Select Country</option>
                            {countries.map((country) => (
                              <option key={country.code} value={country.name}>
                                {country.name}
                              </option>
                            ))}
                          </select>
                        </div>
                        <span className="text-danger">{errors.nationality?.message}</span>
                      </div>


                      <div className="col-6">
                        <label htmlFor="gender" className="form-label">Gender</label>
                        <div className="input-group has-validation">
                          <select id="gender" {...register("gender")} className="form-control">
                            <option value="">Select option</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                            <option value="Other">Other</option>
                          </select>
                        </div>
                        <span className="text-danger">{errors.gender?.message}</span>

                      </div>
                      <div className="col-6">
                        <label htmlFor="yourUsername" className="form-label"> Course</label>
                        <div className="input-group has-validation">
                          <select  {...register("course_id", { required: true })} className="form-control">

                            {!courseId && <option value="100"> Free Course</option>}
                            {
                              courseOptions.map((item) => {
                                return (
                                  <option key={item.course_id} value={item.course_id}>{item.course_name}</option>
                                )
                              })
                            }
                          </select>
                        </div>
                        <span className="text-danger">{errors.course_id?.message}</span>
                      </div>
                      <div className="col-6">
                        <label htmlFor="dateofirth" className="form-label">Date Of Birth</label>
                        <div className="input-group has-validation">
                          <input type="date" {...register("dob")} className="form-control" id="dob" />
                        </div>
                        <span className="text-danger">{errors.dob?.message}</span>
                      </div>
                      <div className="col-6">
                        <label htmlFor="address" className="form-label"> Address</label>
                        <div className="input-group has-validation">
                          <input type="address"  {...register("address")} className="form-control" id="yourUsername" />
                        </div>
                        <span className="text-danger">{errors.address?.message}</span>
                      </div>
                      <div className="col-6">
                        <label htmlFor="company" className="form-label">Company</label>
                        <div className="input-group has-validation">
                          <input type="company"  {...register("company")} className="form-control" id="company" />
                        </div>
                        <span className="text-danger">{errors.company?.message}</span>
                      </div>
                      <div className="col-6">
                        <label htmlFor="job_position" className="form-label">Job Position</label>
                        <div className="input-group has-validation">
                          <input type="job_position"  {...register("job_position")} className="form-control" id="job" />
                        </div>
                        <span className="text-danger">{errors.job_position?.message}</span>
                      </div>
                      <div className="col-6">
                        <label htmlFor="email" className="form-label">Email Address</label>
                        <div className="input-group has-validation">
                          <input type="email"  {...register("email")} className="form-control" id="email" />
                        </div>
                        <span className="text-danger">{errors.email?.message}</span>
                      </div>
                      <div className="col-6">
                        <label htmlFor="source" className="form-label">How did you hear about QHSE International?</label>
                        <div className="input-group has-validation">
                          <input type="source"  {...register("source")} className="form-control" id="source" />
                        </div>
                        <span className="text-danger">{errors.source?.message}</span>
                      </div>


                      <div className="col-12">
                        <div className="input-group has-validation">
                          <input type="checkbox"  {...register("term")} />
                          <label htmlFor="term" className="form-label"> &nbsp; I read, understand, and agree to the <a className="text-warning" href="https://app.qhseinternational.com/quality-policy" target="_blank">terms and conditions </a>set forth by QHSE International</label>
                        </div>
                        <span className="text-danger">{errors.term?.message}</span>
                      </div>

                      <div className="col-12">
                        {isLoading.status !== 'pending' ?

                          <button type="submit" className="btn btn-warning w-100" onClick={handleSubmit(onSubmit)}>Register Now</button>
                          :
                          <button className="btn btn-warning w-100" ><div className="spinner-border text-muted"></div></button>
                        }

                        <p className="text-center"><br /><Link to="/login" className="text-success">Login ? </Link></p>
                      </div>
                      <div className="col-12">
                      </div>
                    </form>

                  </div>
                </div>

              </div>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
}